import RestClient from 'rest_client/rest_client';
import FormValidator from 'validator/form_validator';
import FormValuesSerializer from 'serializers/form_values_serializer';

import { FormEventHandler, FormEvents } from '../../events/form_event_handler';
import { FormAPI, ApplyModes, ProcessAPI } from 'lecom-api';
import SubmitErrorResponseHandler from '../submit_error_response_handler';
import { parseActionParams } from '../../helpers/action_params_helper';
import ProcessActionRoutes from '../../../process/constants/process_action_routes';

export const execute = (action) => {
	return new Promise((resolve, reject) => {
		const formAPI = FormAPI.form(action.formId);

		formAPI.waitingForAction(true).errors({}).apply()
			.then(validateFormForAction.bind(this, formAPI, action))
			.then(submitForm.bind(this, formAPI, action, resolve, reject))
			.catch(handleValidationError.bind(this, formAPI, action));
	});
};


const validateFormForAction = (formAPI, action) => {
	return new Promise((resolve, reject) => {
		const formFields = Object.keys(formAPI.get("fields")).map(field => formAPI.get("fields")[field]);
		const actionId = action.id;
		const errorsInputRequired = FormValidator.validate(formFields, actionId);
		const errorsInputRequiredClone = Object.assign({}, errorsInputRequired);
		const errorsLength = Object.keys(errorsInputRequiredClone).length;

		formAPI.errors(errorsInputRequired).apply().then(() => {
			formAPI.publish(FormEvents.SUBMIT, action.id, reject, resolve);
			!errorsLength ? resolve() : reject();
		});
	});
};

const handleValidationError = (formAPI, action) => {
	window.scrollTo(0, 0);
	formAPI.publish(FormEvents.VALIDATION_ERROR, action.id);

	formAPI.waitingForAction(false);
	formAPI.apply();

	let msgErrorLength = $('.flash--error').length;
	
	if(msgErrorLength){
		let msgError = $('.flash--error .card-content div');
		msgError.attr('tabindex', '0').focus();
	}
};

const submitForm = (formAPI, action, resolve, reject) => {
	const { url, params, method } = buildFormRequest(formAPI, action);
	const form = ProcessAPI.currentProcess().form();

	params.data.values = params.data.values.filter(val => {
		const field = form.fields(val.id);
		return field && !field.hidden();
	});

	return RestClient.load(url, params, method)
		.then(handleSubmissionSuccess.bind(this, formAPI, action, resolve))
		.catch(handleSubmissionError.bind(this, formAPI, action, reject));
};

const buildFormRequest = (formAPI, action) => {
	return {
		url: action.actionUrl,
		params: buildFormRequestParams(formAPI, action),
		method: action.method
	};
};

const buildDataPrint = (formAPI, actionUrl) => {
	let paramsDataPrint = null;
	const routesForDataPrint = [
		ProcessActionRoutes.CANCEL_PROCESS,
		ProcessActionRoutes.COMPLETE_ACTIVITY,
		ProcessActionRoutes.FINISH_ACTIVITY
	];

	if (routesForDataPrint.includes(actionUrl || '')) {
		paramsDataPrint = [];

		const groupsVisible = Form.groups().filter(group => group.visible() !== false || (group.visible() === false && !group.name()) && group.fields().length);

		groupsVisible.forEach(group => {
			paramsDataPrint.push({
				id: group._identifier || '',
				label: group._name || '',
				className: "",
				lineBreak: "",
				type: "GROUP"
			});

			const fieldsVisible = group.fields().filter(field => field.visible() !== false);

			fieldsVisible.forEach(field => {
				if (field.type() === 'GRID') {
					const columnsVisible = field.columns()
						.filter(column => column.visible !== false)
						.map(column => ({
							format: column.format,
							label: column.label,
							name: column.name
						}));

					paramsDataPrint.push({
						id: field.id || '',
						label: field.label() || '',
						className: field.className() || '',
						lineBreak: field.lineBreak() || '',
						type: field.type() || '',
						columns: columnsVisible
					});
				} else if(field.type() === 'LABEL'){
					paramsDataPrint.push({
						id: field.id || '',
						label: field.label() || '',
						className: field.className() || '',
						lineBreak: field.lineBreak() || '',
						type: field.type() || '',
						size: field.size() || '',
						background: field.backgroundColor() || '',
						color: field.color() || '',
						align: field.align() || ''
					});
				} else {
					paramsDataPrint.push({
						id: field.id || '',
						label: field.label() || '',
						className: field.className() || '',
						lineBreak: field.lineBreak() || '',
						type: field.type() || '',
						prefix: field.prefix() || ''
					});
				}
			});
		});
	}

	return paramsDataPrint;
};

const buildFormRequestParams = (formAPI, action) => {
	const formId = formAPI.get("formId");
	const storeFormId = formAPI.get("id");
	const serializedFormValues = FormValuesSerializer.serialize({ formId: storeFormId });
	const parsedAdditionalParams = parseActionParams(action, action.additionalParams);
	const dataPrintEnabled = formAPI.get("dataPrintEnabled");
	return Object.assign({
		formId,
		submitFormActionId: action.formActionId,
		data: Object.assign({}, serializedFormValues, parsedAdditionalParams),
		dataPrint: dataPrintEnabled ? buildDataPrint(formAPI, action.actionUrl) : []
	}, parsedAdditionalParams);
};

const handleSubmissionSuccess = (formAPI, action, resolve, response) => {
	const request = buildFormRequest(formAPI, action);
	FormEventHandler.publish(FormEvents.SUBMIT_SUCCESS, formAPI.storeId, action.id, response, request);
	window.scrollTo(0, 0);

	formAPI.waitingForAction(false).apply().then(resolve);
};

const handleSubmissionError = (formAPI, action, reject, reason) => {
	FormEventHandler.publish(FormEvents.SUBMIT_ERROR, formAPI.storeId, action.id, reason);
	SubmitErrorResponseHandler.execute(action.formId, reason);
	window.scrollTo(0, 0);

	formAPI.waitingForAction(false).apply().then(reject);
};

export default {
	execute
};
